import { create } from "zustand";

export const useConfirmId = create((set: any) => ({
  confirmId: false,
  setConfirmId: (error: any) => set({ confirmId: error }),
}));
